import React, { Component } from 'react';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';

const styles = () => createStyles({
    root: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        alignSelf: 'center',
        textAlign: 'center',
    }
});

class CenteredSecondaryText extends Component<WithStyles<typeof styles>> {
    render() {
        const { children, classes } = this.props

        return (
            <div className={classes.root}>
                <Typography color="textSecondary">{children}</Typography>
            </div>
        )
    }
}

export default withStyles(styles)(CenteredSecondaryText);